import { HttpStatusCode } from "axios";
import commonService from "../../apiServices/common/commonService";
import keyCloakApiService from "../../apiServices/common/keyCloakApiService";
import {
  setCollegeDepartments,
  setCollegeName,
  setColleges,
  setCollegeTypes,
  setDepartmentName,
  setDepartments,
  setDescriptionText,
  setLoginUsers,
  setNotificationTypes,
  setPageBlocks,
  setPortalRating,
  setReportFrequencies,
  setReportNamesWithDescription,
  setTaskRespects,
  setTaskStatus,
  setToMailId,
  setCampusSafetyToMailId,
  setTrainingCategories,
  setTrainingNameWithDescriptionAndDate,
  setUniversities,
  setUserTypes,
  setSubSteps,
  setStudentType,
  setVersion,
  setWidgetPageBlocks,
  setAIAgents,
  setUserSubRoles,
  //setUserDetails
} from "../../store/slices/common/commonSlice";
import { IDropdownData } from "../../models/ICommon";
import { alertConstants } from "../../helper/sweet-alert";
import { setEventDetails } from "../../store/slices/common/studentEventsSlice";
import { ISendMail } from "../../models/common/IUserProfile";
import { IUpdateUserProfile } from "../../models/common/IUpdateUserProfile";
import keyCloackService from "../../helper/key-cloack-service";
import { setUserProfileData } from "../../store/slices/user/userSlice";
import { emailBlockId } from "../../constants/pageBlocks";

export function getColleges() {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getColleges();
    if (response?.success === true) {
      dispatch(setColleges(response.data));
    } else {
    }
  };
}

export function getPageBlocks() {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getPageBlocks();
    if (response?.success === true) {
      dispatch(setPageBlocks(response.data));
    } else {
    }
  };
}

export function getUserTypes() {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getUserTypes();
    if (response?.success === true) {
      dispatch(setUserTypes(response.data));
    } else {
    }
  };
}

export function getUserSubRoles() {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getUserSubRoles();
    if (response?.success === true) {
      dispatch(setUserSubRoles(response.data));
    } else {
    }
  };
}

export function getDepartments(collegeId?: number) {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getDepartments(collegeId);
    if (response?.success === true) {
      dispatch(setDepartments(response.data));
    } else {
    }
  };
}

export function getNotificationTypes() {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getNotificationTypes();
    if (response?.success === true) {
      dispatch(setNotificationTypes(response.data));
    } else {
    }
  };
}

export function getUniversities() {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getUniversities();
    if (response?.success === true) {
      dispatch(setUniversities(response.data));
    } else {
    }
  };
}

export function getUserPageBlocks(userType?: number, masterType?: string) {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getUserPageBlocks(userType, masterType);
    if (response?.success === true) {
      dispatch(setPageBlocks(response.data));
    } else {
    }
  };
}

export function getUserWidgetPageBlocks(userType?: number, masterType?: string) {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getUserPageBlocks(userType, masterType);
    if (response?.success === true) {
      dispatch(setWidgetPageBlocks(response.data));
    } else {
    }
  };
}

export function getreportFrequencies() {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getreportFrequencies();
    if (response?.success === true) {
      dispatch(setReportFrequencies(response.data));
    } else {
    }
  };
}

export function getReportNamesWithDescription() {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getReportNamesWithDescription();
    if (response?.success === true) {
      dispatch(setReportNamesWithDescription(response.data));
    } else {
    }
  };
}

export function getTrainingCategories() {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getTrainingCategories();
    if (response?.success === true) {
      dispatch(setTrainingCategories(response.data));
    } else {
    }
  };
}

export function getAllTrainingInformation() {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getAllTrainingInformation();
    if (response?.success === true) {
      dispatch(setTrainingNameWithDescriptionAndDate(response.data));
    } else {
    }
  };
}

export function getCollegeAdmins() {
  return async function (dispatch: any, getState: any) {
    let response = await keyCloakApiService.getUsersBasedOnRole("College Admin");
    if (response?.status === HttpStatusCode.Ok) {
      let data: IDropdownData[] = response.data?.map((it: any) => {
        return {
          id: it.id,
          name: it.firstName + " " + it.lastName
        };
      });
      dispatch(setLoginUsers(data));
    } else {
    }
  };
}

export function getDepartmentAdmins() {
  return async function (dispatch: any, getState: any) {
    let response = await keyCloakApiService.getUsersBasedOnRole("Department Admin");
    if (response?.status === HttpStatusCode.Ok) {
      let data: IDropdownData[] = response.data?.map((it: any) => {
        return {
          id: it.id,
          name: it.firstName + " " + it.lastName
        };
      });
      dispatch(setLoginUsers(data));
    } else {
    }
  };
}

export function getCollegeDepartments(collegeIds: string) {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getCollegeDepartments(collegeIds);
    if (response?.success === true) {
      dispatch(setCollegeDepartments(response.data));
    } else {
    }
  };
}

export function getTaskRespects() {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getTaskRespects();
    if (response?.success === true) {
      dispatch(setTaskRespects(response.data));
    } else {
    }
  };
}

export function getTaskStatus() {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getTaskStatus();
    if (response?.success === true) {
      dispatch(setTaskStatus(response.data));
    } else {
    }
  };
}

export function createPortalRating(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.createPortalRatinng(data);
    if (response?.success === true) {
      callback(alertConstants.success);
      dispatch(getPortalRating());
    } else {
      callback(alertConstants.error);
    }
  }
};

export function getPortalRating() {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getPortalRatinng();
    if (response?.success === true) {
      dispatch(setPortalRating(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getEventDetails(date: string) {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getEventDetails(date)
    if (response?.success === true) {
      dispatch(setEventDetails(response.data));
    } else {
      console.error(response.error);
    }
  };
}

export function getCollegeTypes() {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getCollegeTypes();
    if (response?.success === true) {
      dispatch(setCollegeTypes(response.data));
    } else {
      console.error(response.error);
    }
  };
}

export function getDepartmentName(college: string) {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getDepartmentName(college);
    if (response?.success === true) {
      dispatch(setDepartmentName(response.data));
    } else {
      console.error(response.error);
    }
  };
}

export function getCollegeName(userType: number) {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getCollegeName(userType);
    if (response?.success === true) {
      dispatch(setCollegeName(response.data));
    } else {
      console.error(response.error);
    }
  };
}

export function createFeedback(Feedback: ISendMail, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.createFeedback(Feedback);
    if (response?.success === true) {
      callback(alertConstants.emailSuccess);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function getToMailId(emailblockId: number) {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getToMailId(emailblockId);
    if (response?.success === true) {
      if (emailblockId == emailBlockId.Campus_Safety) {
        dispatch(setCampusSafetyToMailId(response.data));
      }
      else {
        dispatch(setToMailId(response.data));
      }
    } else {
      console.error(response.error);
    }
  };
}

export function getAllStudentType() {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getAllStudentType();
    if (response?.success === true) {
      dispatch(setStudentType(response.data));
    } else {
      console.error(response.error);
    }
  };
}

export function getDescriptionText(pageBlockId: number) {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getDescriptionText(pageBlockId);
    if (response?.success === true) {
      dispatch(setDescriptionText(response.data));
    } else {
    }
  };
}

export function getSubSteps() {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getSubSteps();
    if (response?.success === true) {
      dispatch(setSubSteps(response.data));
    } else {
    }
  };
}


export function updateUserProfile(userData: IUpdateUserProfile) {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.updateUserProfile(userData);
    if (response?.success === true) {
      console.log(response.message);
    } else {
      console.log(response.error);
    }
  };
}

export function changeUserRole(userData: IUpdateUserProfile, navigateToLogin: Function, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.updateUserProfile(userData);
    if (response?.success === true) {
      try {
        await keyCloackService.refreshToken();
        await dispatch(setUserProfileData(undefined));
        navigateToLogin()
      } catch (error) {
        console.error(error);
      }
    } else {
      callback();
      console.log(response.error);
    }
  };
}

export function getAllVersion(studentCategory?: number) {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getAllVersion(studentCategory);
    if (response?.success === true) {
      dispatch(setVersion(response.data));
    } else {
      console.error(response.error);
    }
  };
}

export function getAIAgents(userType? : number) {
  return async function (dispatch: any, getState: any) {
    let response = await commonService.getAIAgents(userType);
    if (response?.success === true) {
      dispatch(setAIAgents(response.data));
    } else {
    }
  };
}